// 申请调解
import * as ApiCase from "@/api/application.js";
const state = {
  //   token: getToken(),
  userInfo: {},
  caseDetails: {},
  currentTab:{ Id:null , previous: null, next: null, name: null, title: null }
};

const mutations = {
  SET_USERINFO: (state, userInfo) => {
    state.userInfo = userInfo;
  },
  SET_CURRENTTAB: (state, currentTab) => {
    state.currentTab = currentTab;
  },
};

const actions = {
    // 获取申请单详情
  getCaseDetail({ commit, state }) {
    return new Promise((resolve, reject) => {
      ApiCase.getCaseDetails(req)
        .then(res => {
          resolve("成功");
        })
        .catch(err => {
          console.log("err :>> ", err);
          reject(err);
        });
    });
    
  },
  setApplierUserInfo({ commit, state }){
},
// 保存tab 变化
setTabChange({commit},argCurrentTab){
  return new Promise((resolve)=>{
    commit('SET_CURRENTTAB',argCurrentTab)
     resolve(state.currentTab)
  })
}
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
